import React, { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import useAuth from "system/APIAuth";
import { registerAPIRequestErrorCallback, unregisterAPIRequestErrorCallback, APIError } from './APIRequest';
import { sessionToken } from './InfegyUser';

export default function AuthRequired() {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check auth status when component mounts or auth state changes
    const checkAuth = () => {
      // Check if user is authenticated
      const isAuthenticated = Boolean(auth.user !== undefined && auth.user.id);
      const token = sessionToken();

      if (!isAuthenticated && !token) {
        // No authenticated user and no token, redirect to login
        navigate('/login', {
          state: { from: location },
          replace: true
        });
      }
    };

    checkAuth();

    // Handle API authentication errors (like 401s)
    const handleAuthError = (error: APIError) => {
      if (error.code === 401) {
        navigate('/login', {
          state: { from: location },
          replace: true
        });
      }
    };

    registerAPIRequestErrorCallback(handleAuthError);

    return () => {
      unregisterAPIRequestErrorCallback(handleAuthError);
    };
  }, [auth.user, auth.token, location, navigate]);

  // Check if token exists but no user yet - auth might be in progress
  if (sessionToken() && !auth.user) {
    return null; // Render nothing while authentication is in progress
  }

  const isAuthenticated = auth.isAuthenticated();

  return (
    <>
      {isAuthenticated &&
        <Outlet />
      }
    </>
  );
}